module.exports = __webpack_public_path__ + "static/media/crop_icon.52db0b0a.svg";